import { render, staticRenderFns } from "./RecommendItem.vue?vue&type=template&id=df930e26&scoped=true"
import script from "./RecommendItem.vue?vue&type=script&lang=js"
export * from "./RecommendItem.vue?vue&type=script&lang=js"
import style0 from "./RecommendItem.vue?vue&type=style&index=0&id=df930e26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df930e26",
  null
  
)

export default component.exports